import { Box, Flex, Typography } from '@iheartjane/reefer';
import type { PaddingProperties } from '@iheartjane/reefer';
import { formatCurrency } from '@iheartjane/utils';

import styles from './progressBar.module.css';

interface ProgressBarProps extends PaddingProperties {
  progressInGrams?: boolean;
  qualifiedProductsTotal: number;
  qualifyingTargetAmount: number;
  unlocked: boolean;
}

export const ProgressBar = ({
  progressInGrams = false,
  qualifiedProductsTotal,
  qualifyingTargetAmount,
  unlocked,
  ...spacingProps
}: ProgressBarProps) => {
  const qualifiedTotal = Math.max(qualifiedProductsTotal, 0);
  const progress =
    qualifyingTargetAmount > 0
      ? Math.min(100, (qualifiedTotal / qualifyingTargetAmount) * 100)
      : 0;

  return (
    <Box {...spacingProps}>
      <Box
        data-testid="progress-bar"
        height={8}
        width="100%"
        borderRadius="sm"
        background="transparent-black-five"
      >
        <Box
          data-testid="progress-bar-fill"
          background={unlocked ? 'info' : 'grays-black'}
          height={8}
          borderRadius="sm"
          width={`${progress}%`}
          className={styles['progressBar']}
        />
      </Box>
      <Flex justifyContent="space-between" mt={8}>
        <Typography as="span" color="grays-mid">
          {progressInGrams
            ? `${qualifiedTotal}g`
            : formatCurrency(qualifiedTotal, true)}
        </Typography>
        <Typography as="span" color="grays-mid">
          {progressInGrams
            ? `${qualifyingTargetAmount}g`
            : formatCurrency(qualifyingTargetAmount, true)}
        </Typography>
      </Flex>
    </Box>
  );
};
